/**
 * Cron Job Types
 */

export enum CronJobType {
  LOSSBACK = 'lossback',
  REPORT = 'report',
  NOTIFICATION = 'notification',
  CLEANUP = 'cleanup',
  BACKUP = 'backup',
  SYNC = 'sync',
  DEPOSIT = 'deposit',      // ✅ ฝากเงิน
  WITHDRAW = 'withdraw',    // ✅ ถอนเงิน
  WINLOSE = 'winlose',      // ✅ Winlose calculation
  ACHIEVEMENT = 'achievement', // ✅ Achievement checking
  COMMISSION = 'commission',  // ✅ Commission calculation
}

export enum CronJobStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  RUNNING = 'running',
  PENDING = 'pending',
}

export const CRON_JOB_TYPES = [
  { value: CronJobType.LOSSBACK, label: 'คืนยอดเสีย', icon: 'percent' },
  { value: CronJobType.REPORT, label: 'รายงาน', icon: 'file-text' },
  { value: CronJobType.NOTIFICATION, label: 'แจ้งเตือน', icon: 'bell' },
  { value: CronJobType.CLEANUP, label: 'ล้างข้อมูล', icon: 'trash' },
  { value: CronJobType.BACKUP, label: 'สำรองข้อมูล', icon: 'database' },
  { value: CronJobType.SYNC, label: 'ซิงค์ข้อมูล', icon: 'refresh-cw' },
  { value: CronJobType.DEPOSIT, label: 'ฝากเงิน', icon: 'arrow-down-circle' },
  { value: CronJobType.WITHDRAW, label: 'ถอนเงิน', icon: 'arrow-up-circle' },
  { value: CronJobType.WINLOSE, label: 'Winlose', icon: 'percent' },
  { value: CronJobType.ACHIEVEMENT, label: 'Achievement', icon: 'award' },
  { value: CronJobType.COMMISSION, label: 'Commission', icon: 'dollar-sign' },
] as const

// Common cron schedules
export const CRON_SCHEDULES = [
  // ✅ วินาที (สำหรับฝากถอน)
  { value: '*/5 * * * * *', label: 'ทุก 5 วินาที' },
  { value: '*/10 * * * * *', label: 'ทุก 10 วินาที' },
  { value: '*/18 * * * * *', label: 'ทุก 18 วินาที' },
  { value: '*/30 * * * * *', label: 'ทุก 30 วินาที' },
  { value: '*/60 * * * * *', label: 'ทุก 60 วินาที (1 นาที)' },
  // นาที
  { value: '*/5 * * * *', label: 'ทุก 5 นาที' },
  { value: '*/15 * * * *', label: 'ทุก 15 นาที' },
  { value: '*/30 * * * *', label: 'ทุก 30 นาที' },
  { value: '0 * * * *', label: 'ทุกชั่วโมง' },
  { value: '0 */2 * * *', label: 'ทุก 2 ชั่วโมง' },
  { value: '0 */6 * * *', label: 'ทุก 6 ชั่วโมง' },
  { value: '0 0 * * *', label: 'ทุกวัน เที่ยงคืน' },
  { value: '0 2 * * *', label: 'ทุกวัน ตี 2' },
  { value: '0 6 * * *', label: 'ทุกวัน 6 โมงเช้า' },
  { value: '0 0 * * 0', label: 'ทุกสัปดาห์ (อาทิตย์)' },
  { value: '0 0 1 * *', label: 'ทุกเดือน (วันที่ 1)' },
] as const

export interface CronJob {
  objectId: string
  name: string
  description: string
  type: CronJobType
  schedule: string
  is_active: boolean
  last_run_at?: string
  last_status?: CronJobStatus
  last_error?: string
  last_duration?: number
  next_run_at?: string
  run_count: number
  config: Record<string, any>
  createdAt: string
  updatedAt: string
}

export interface CronJobFormData {
  name: string
  description: string
  type: CronJobType
  schedule: string
  is_active: boolean
  config: Record<string, any>
}

export interface CronJobStats {
  total: number
  active: number
  inactive: number
  running: number
  failed: number
}

export interface CronJobQueryParams {
  query?: string
  type?: CronJobType
  is_active?: boolean
  page?: number
  limit?: number
}









